import React, { useCallback,Suspense } from "react";
import { Form, Grid  } from "semantic-ui-react";
import GoodsLocation from "./goodsLocation";
import WarehouseDetails from "./warehouseDetails";
import TradeTerms from "./tradeTerms";
import HeaderInfo from "./headerInfo";
import { FormTitle } from "../../../../commonComponents/FormTitle";
import Itinerary from "./itinerary";
import { TranslateContext } from "../../TranslateContext";
const BorderTransportMode = React.lazy(() => import('../DMS/borderTransportMode'));
const DepartureTransportMode = React.lazy(() => import('../DMS/departureTransportMode'));
import TransitMode from "./TransitMode";
const BorderTransportModeAGS = React.lazy(() => import('../AGS/borderTransportMode'));
const DepartureTransportModeAGS = React.lazy(() => import('../AGS/departureTransportMode'));

import { useDispatch } from "react-redux";
import { updateTransportationDetails } from "../../../actions";
import  validate  from "validate.js"



const  TransportationForm = ({isImportShipment,isDMS,fieldPattern,validateError,saveForm}) =>{
  const translate = React.useContext(TranslateContext).translate
  const dispatch=useDispatch()
  
  const saveData=useCallback(async(payload)=>{
    const {modeType,...rest}=payload
    const response=await saveForm({transportation:{[`${modeType}`]:rest}})
    if(!rest.transportId)
      onUpdate({modeType,transportId:response.responseMessage})
    
  },[saveForm,onUpdate])
  const onUpdate=useCallback((payload)=>{
    const {modeType,...rest}=payload
    dispatch(updateTransportationDetails({key:modeType,payload:rest}))
  },[dispatch,updateTransportationDetails])
 
  
  const RenderMode=useCallback((params)=>(<TransitMode {...params} />),[])
  return (
    <Form.Group className="float-container">
      <FormTitle title={translate("TRANSPORTATION")}></FormTitle>
      <Grid className="kn__grid">
        <HeaderInfo saveForm={saveForm} fieldPattern={fieldPattern} validateError={validateError} ></HeaderInfo>
         
       
        <GoodsLocation saveForm={saveForm} fieldPattern={fieldPattern} validateError={validateError} isDMS={isDMS} isImportShipment={isImportShipment}></GoodsLocation>
        <WarehouseDetails saveForm={saveForm} fieldPattern={fieldPattern} validateError={validateError} ></WarehouseDetails>
        <Suspense fallback={<div>Loading...</div>}>
           {
            isDMS ? <BorderTransportMode onUpdate={onUpdate} saveData={saveData}
           isImportShipment={isImportShipment}
           title="BORDER Transit Mode"
           modeType="borderTransitMode"
           renderForm={RenderMode}
           />
           :
           <BorderTransportModeAGS fieldPattern={fieldPattern} validateError={validateError} validate={validate}  onUpdate={onUpdate} saveData={saveData}
           isImportShipment={isImportShipment}
           title="BORDER Transit Mode"
           modeType="borderTransitMode"
           renderForm={RenderMode}
           />
}

              {
               isDMS ? <DepartureTransportMode 
              isImportShipment={isImportShipment} onUpdate={onUpdate} saveData={saveData}
              renderForm={RenderMode}
              title={`${isImportShipment ? "ARRIVAL_TRANSIT_MODE" : "DEPARTURE_TRANSIT_MODE"}`}  
              modeType={isImportShipment?"ArrivalTransitMode" :"departureTransitMode"}
              />
              :
              <DepartureTransportModeAGS validateError={validateError}  fieldPattern={fieldPattern}
              isImportShipment={isImportShipment} onUpdate={onUpdate} saveData={saveData}
              renderForm={RenderMode}
              title={`${isImportShipment ? "ARRIVAL_TRANSIT_MODE" : "DEPARTURE_TRANSIT_MODE"}`}  
              modeType={isImportShipment?"ArrivalTransitMode" :"departureTransitMode"}
              />
              }
          </Suspense>
              <TradeTerms saveForm={saveForm} fieldPattern={fieldPattern}  validateError={validateError} isImportShipment={isImportShipment} isDMS={isDMS}></TradeTerms>
              <Itinerary saveForm={saveForm} isImportShipment={isImportShipment} isDMS={isDMS}></Itinerary>
           
      </Grid>
    </Form.Group>
  );
}

export default TransportationForm
